import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML fragment before it is rendered via `v-html`.
 *
 * Every `v-html` sink is an XSS surface: even operator-authored content (legal
 * pages, CMS copy) goes through the content pipeline, so a poisoned source
 * would otherwise execute arbitrary script in the user's session. DOMPurify
 * strips scripts, event handlers, and dangerous URLs while preserving normal
 * formatting markup.
 */
export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) {
    return '';
  }
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
}

/**
 * Sanitize a server-generated SVG (e.g. a TOTP QR code) before `v-html`.
 *
 * SVG can carry `<script>` and event handlers, so it must be cleaned even when
 * it comes from our own API. The SVG profile keeps vector markup but removes
 * active content.
 */
export function sanitizeSvg(dirty: string | null | undefined): string {
  if (!dirty) {
    return '';
  }
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { svg: true, svgFilters: true } });
}
